export const kitNames = {
    "LDNA-000-AT": "Ancestry kit",
    "LDNA-000-MT": "Ancestry kit",
    "LDNA-001-AU": "Ancestry kit",
    "LDNA-001-CA": "Ancestry kit",
    "LDNA-001-CGL": "Ancestry kit",
    "LDNA-001-DCD": "Ancestry kit",
    "LDNA-001-EU": "Ancestry kit",
    "LDNA-001-NZ": "Ancestry kit",
    "LDNA-001-ROW": "Ancestry kit",
    "LDNA-001-UK": "Ancestry kit",
    "LDNA-001-US": "Ancestry kit",
    "LDNA-001-USA": "Ancestry kit",
    "LDNA-002-AU": "Ancestry kit",
    "LDNA-002-CA": "Ancestry kit",
    "LDNA-002-EU": "Ancestry kit",
    "LDNA-002-NZ": "Ancestry kit",
    "LDNA-002-ROW": "Ancestry kit",
    "LDNA-002-UK": "Ancestry kit",
    "LDNA-002-US": "Ancestry kit",
    "LDNA-002-USA": "Ancestry kit",
    "LDNA-FAM-001": "Ancestry kit",
    "LDNA-ANCESTRY-NEANDERTHAL-UK" : 'Ancestry kit',
    "LDNA-FMP-FULLANCESTRY-AU": "Ancestry kit",
    "LDNA-FMP-FULLANCESTRY-CA": "Ancestry kit",
    "LDNA-FMP-FULLANCESTRY-EU": "Ancestry kit",
    "LDNA-FMP-FULLANCESTRY-NZ": "Ancestry kit",
    "LDNA-FMP-FULLANCESTRY-ROW": "Ancestry kit",
    "LDNA-FMP-FULLANCESTRY-UK": "Ancestry kit",
    "LDNA-FMP-FULLANCESTRY-US": "Ancestry kit",
    "LDNA-GOUS-UK": "Gousto ancestry kit",
    "LDNA-SEQ-AU": "Ancestry kit",
    "LDNA-SEQ-CA": "Ancestry kit",
    "LDNA-SEQ-EU": "Ancestry kit",
    "LDNA-SEQ-NZ": "Ancestry kit",
    "LDNA-SEQ-ROW": "Ancestry kit",
    "LDNA-SEQ-UK": "Ancestry kit",
    "LDNA-SEQ-USA": "Ancestry kit",
    "LDNA-STACK-US": "Ancestry kit",
    "LDNA-STACK-WELLBEING-ANCESTRY-US": "Wellbeing & ancestry kit",
    "LDNA-STARTER-AU": "Starter kit",
    "LDNA-STARTER-CA": "Starter kit",
    "LDNA-STARTER-DIGITAL-AU": "Digital upload",
    "LDNA-STARTER-DIGITAL-CA": "Digital upload",
    "LDNA-STARTER-DIGITAL-EU": "Digital upload",
    "LDNA-STARTER-DIGITAL-NZ": "Digital upload",
    "LDNA-STARTER-DIGITAL-ROW": "Digital upload",
    "LDNA-STARTER-DIGITAL-UK": "Digital upload",
    "LDNA-STARTER-DIGITAL-US": "Digital upload",
    "LDNA-STARTER-EU": "Starter kit",
    "LDNA-STARTER-NZ": "Starter kit",
    "LDNA-STARTER-ROW": "Starter kit",
    "LDNA-STARTER-UK": "Starter kit",
    "LDNA-STARTER-USA": "Starter kit",
    "LDNA-WELLBEING-ANCESTRY-AU": "Wellbeing & ancestry kit",
    "LDNA-WELLBEING-ANCESTRY-CA": "Wellbeing & ancestry kit",
    "LDNA-WELLBEING-ANCESTRY-EU": "Wellbeing & ancestry kit",
    "LDNA-WELLBEING-ANCESTRY-NZ": "Wellbeing & ancestry kit",
    "LDNA-WELLBEING-ANCESTRY-ROW": "Wellbeing & ancestry kit",
    "LDNA-WELLBEING-ANCESTRY-UK": "Wellbeing & ancestry kit",
    "LDNA-WELLBEING-ANCESTRY-USA": "Wellbeing & ancestry kit",
    "LDNA-WELLBEING-AU": "Wellbeing kit",
    "LDNA-WELLBEING-CA": "Wellbeing kit",
    "LDNA-WELLBEING-EU": "Wellbeing kit",
    "LDNA-WELLBEING-NZ": "Wellbeing kit",
    "LDNA-WELLBEING-ROW": "Wellbeing kit",
    "LDNA-WELLBEING-UK": "Wellbeing kit",
    "LDNA-WELLBEING-USA": "Wellbeing kit",
    "LDNA-YULIFE-UK" : 'DNA Kit',
};

// What a profile's kit is called. Only LT barcodes are uploads, so a posted kit whose SKU isn't
// listed above is still a DNA kit.
// Kit statuses that mean the sample will never give results on this barcode: the lab couldn't
// test it, the uploaded file failed its checks, or the kit was cancelled. Nothing that builds
// on its DNA, such as a digital upgrade, can be bought for it; ecommerce refuses those too.
const NO_RESULTS_STATUSES = ["testing_failed", "transfer_qc_failed", "cancelled"];

// The kit status that rules out upgrades for `test` (a test from the account's tests), or null.
export const statusWithoutResults = (test) =>
    NO_RESULTS_STATUSES.includes(test?.raw_status) ? test.raw_status : null;

export const kitLabel = (barcode, productSku) => {
    if (barcode?.endsWith("E")) return "Epigenetic";
    if (kitNames[productSku]) return kitNames[productSku];
    if (barcode?.startsWith("LT")) return "Digital upload";
    return "DNA kit";
};

/*
 * Understanding this file
 * The key concept surrounding this file is that it categorizes steps in four key ways. Does the step
 * belong to a kit or a test, and is that kit or test an upload or a physical kit.
 * For any given state that a kit, or a test, could be in, we define a series steps in a simple
 * array. Each state that the kit or test could be in will have any number of incomplete, active,
 * and completed steps. Optionally, it may also have any number of failed steps.
 * The steps in this timeline associated with the current step the kit or test is at is then
 * "hydrated" using the decorated*Steps at the top of the file. This is what provides the human
 * friendly name of the step, a description, and a duration.
 * */

const decoratedLDSteps = {
    shipped: {
        name: "Activated",
        description: "Your kit has been successfully activated",
        duration: "-",
    },
    enRoute: {
        name: "En route",
        description: "Your sample is on its way to us",
        duration: "1-3 weeks",
    },
    returned: {
        name: "Received",
        description: "Your sample has been received at the lab",
        duration: "1 week",
    },
    genotyping: {
        name: "Genotyping",
        description: "The lab is sequencing your DNA",
        duration: "3-4 weeks",
    },
    testing: {
        name: "Testing",
        description: "We have received your sequenced DNA from the lab and are now analysing it",
        duration: "72 hours",
    },
    // The same step once the sample has failed, so it doesn't still say it's being analysed.
    testingFailed: {
        name: "Testing",
        description: "We couldn't get a reliable result from your sample",
        duration: "-",
    },
    completed: {
        name: "Completed",
        description: "Your results are complete and ready to view",
        duration: "-",
    },
    updating: {
        name: "Updating",
        description: "Your results are updating",
        duration: "48 hours",
    },
    requestedUpdate: {
        name: "Requested update",
        description: "You requested your results update",
        duration: "-",
    },
    updateComplete: {
        name: "Complete",
        description: "Your results are updated and ready to view",
        duration: "-",
    },
    yNotAvailable: {
        name: "Not available",
        description: "Paternal haplogroup cannot be provided",
        duration: "-",
    },
    cancelled: {
        name: "Cancelled",
        description: "Your kit has been cancelled",
        duration: "-",
    },
    lostInPost: {
        name: "Lost in the post",
        description:
            "Your kit did not reach you. Contact support and we will sort out a replacement",
        duration: "-",
    },
};

const decoratedLTSteps = {
    uploaded: {
        name: "Uploaded",
        description: "Your file has been successfully uploaded",
        duration: "-",
    },
    testing: {
        name: "Testing",
        description: "Analysing your uploaded data",
        duration: "A few hours",
    },
    updating: {
        name: "Updating",
        description: "Your results are updating",
        duration: "A few hours",
    },
    completed: {
        name: "Completed",
        description: "Your results are ready to view",
        duration: "-",
    },
};

const decoratedUpgradeSteps = {
    notAdded: {
        name: "Not added",
        description: "You need to add this test",
        duration: "-",
    },
    pending: {
        name: "Waiting",
        description: "Your additional test has been selected",
        duration: "-",
    },
    processing: {
        name: "Processing",
        description: "Your additional test is being processed",
        duration: "48 hours",
    },
    updating: {
        name: "Updating",
        description: "Your additional test is updating",
        duration: "48 hours",
    },
    completed: {
        name: "Completed",
        description: "Your additional test has been completed",
        duration: "-",
    },
    error: {
        name: "Failed",
        description: "Your additional test failed to process properly",
        duration: "-",
    },
};

const decoratedFNSteps = {
    notOptedIn: {
        name: "Not opted in",
        description: "You need to opt in to be included in our family networks service",
        duration: "-",
    },
    optedIn: {
        name: "Opted in",
        description: "You have opted in to the family networks service",
        duration: "-",
    },
    testing: {
        name: "Testing",
        description: "Analysing your uploaded data",
        duration: "48 hours",
    },
    pending: {
        name: "Pending",
        description: "Waiting for one of our fortnightly runs of family networks",
        duration: "Up to two weeks",
    },
    findingMatches: {
        name: "Finding matches",
        description: "Comparing your DNA against everyone in our database",
        duration: "2 hours",
    },
    matching: {
        name: "Matching",
        description: "Comparing your DNA against everyone in our database",
        duration: "2 hours",
    },
    completed: {
        name: "Completed",
        description: "Check out your matches and wait for the next run of family networks",
        duration: "-",
    },
};

const decoratedVitaminSteps = {
    added: {
        name: "Sign up",
        description: "Sign up with vitamin lab",
        duration: "-",
    },
    expiringSoon: {
        name: "Expiring soon",
        description: "Your vitamin subscription is expiring soon",
    },
    expired: {
        name: "Expired",
        description: "Your vitamin subscription has expired",
    },
};

const decoratedHealthSteps = {
    create: {
        name: "Create",
        description: "Create your health profile",
        duration: "10 minutes",
    },
};

function d(step) {
    return decoratedLDSteps[step];
}

function dLT(step) {
    return decoratedLTSteps[step];
}

function du(step) {
    return decoratedUpgradeSteps[step];
}

function dFN(step) {
    return decoratedFNSteps[step];
}

function dVit(step) {
    return decoratedVitaminSteps[step];
}

function dHealth(step) {
    return decoratedHealthSteps[step];
}

// Helper function to ensure arrays always exist
function ensureArrays(obj) {
    return {
        completeSteps: obj.completeSteps || [],
        activeSteps: obj.activeSteps || [],
        incompleteSteps: obj.incompleteSteps || [],
        failedSteps: obj.failedSteps || [],
        ...obj
    };
}

const kitLT = {
    testing: ensureArrays({
        completeSteps: ["uploaded"].map(dLT),
        activeSteps: ["testing"].map(dLT),
        incompleteSteps: ["completed"].map(dLT),
    }),
    completed: ensureArrays({
        completeSteps: ["uploaded", "testing", "completed"].map(dLT),
        activeSteps: [],
        incompleteSteps: [],
    }),
    transfer_qc_failed: ensureArrays({
        completeSteps: ["uploaded"].map(dLT),
        incompleteSteps: [],
        failedSteps: ["testing"].map(dLT),
    }),
    failed: ensureArrays({
        completeSteps: ["uploaded"].map(dLT),
        incompleteSteps: [],
        failedSteps: ["testing"].map(dLT),
    }),
    testing_failed: ensureArrays({
        completeSteps: ["uploaded"].map(dLT),
        incompleteSteps: [],
        failedSteps: ["testing"].map(dLT),
    }),
    genotyping: ensureArrays({}), // we should probably fix this one
    cancelled: ensureArrays({
        completeSteps: ["uploaded"].map(dLT),
        incompleteSteps: [],
        failedSteps: ["testing"].map(dLT),
    }),
};

const kitLD = {
    shipped: ensureArrays({
        completeSteps: ["shipped"].map(d),
        activeSteps: ["enRoute"].map(d),
        incompleteSteps: ["returned", "genotyping", "testing", "completed"].map(d),
    }),
    returned: ensureArrays({
        completeSteps: ["shipped", "enRoute", "returned"].map(d),
        activeSteps: ["genotyping"].map(d),
        incompleteSteps: ["testing", "completed"].map(d),
    }),
    genotyping: ensureArrays({
        completeSteps: ["shipped", "enRoute", "returned"].map(d),
        activeSteps: ["genotyping"].map(d),
        incompleteSteps: ["testing", "completed"].map(d),
    }),
    testing: ensureArrays({
        completeSteps: ["shipped", "enRoute", "returned", "genotyping"].map(d),
        activeSteps: ["testing"].map(d),
        incompleteSteps: ["completed"].map(d),
    }),
    completed: ensureArrays({
        completeSteps: ["shipped", "enRoute", "returned", "genotyping", "testing", "completed"].map(
            d
        ),
        activeSteps: [],
        incompleteSteps: [],
    }),
    cancelled: ensureArrays({
        completeSteps: [],
        activeSteps: [],
        incompleteSteps: [],
        failedSteps: ["cancelled"].map(d),
    }),
    testing_failed: ensureArrays({
        completeSteps: ["shipped", "enRoute", "returned"].map(d),
        activeSteps: [],
        incompleteSteps: [],
        failedSteps: ["testingFailed"].map(d),
    }),
    // The kit never reached the customer, so nothing before it completed either. Reversible
    // in the api via found_after_loss, which puts the kit back to shipped and this timeline
    // back to the shipped one above. LD only - an LT kit is an upload and is never posted.
    lost_in_post: ensureArrays({
        completeSteps: [],
        activeSteps: [],
        incompleteSteps: [],
        failedSteps: ["lostInPost"].map(d),
    }),
};

const testLT = {
    other: {
        familyMatching: {
            notOptedIn: ensureArrays({
                incompleteSteps: ["notOptedIn", "pending", "findingMatches", "completed"].map(dFN),
                completeSteps: [],
                activeSteps: [],
            }),
            transfer_qc_failed: ensureArrays({
                completeSteps: ["optedIn"].map(dFN),
                activeSteps:[],
                incompleteSteps: [],
                failedSteps: ["testing"].map(dFN),
            }),
            failed: ensureArrays({
                completeSteps: ["optedIn"].map(dFN),
                failedSteps: ["matching"].map(dFN),
            }),
            pending: ensureArrays({
                completeSteps: ["optedIn"].map(dFN),
                activeSteps: ["pending"].map(dFN),
                incompleteSteps: ["findingMatches", "completed"].map(dFN),
            }),
            processing: ensureArrays({
                completeSteps: ["optedIn"].map(dFN),
                activeSteps: ["findingMatches"].map(dFN),
                incompleteSteps: ["completed"].map(dFN),
            }),
            completed: ensureArrays({
                completeSteps: ["optedIn", "pending", "findingMatches", "completed"].map(dFN),
                activeSteps: [],
                incompleteSteps: [],
            }),
        },
    },
    pending: ensureArrays({
        completeSteps: ["uploaded"].map(dLT),
        incompleteSteps: ["testing", "completed"].map(dLT),
        activeSteps: [],
    }),
    processing: ensureArrays({
        completeSteps: ["uploaded"].map(dLT),
        incompleteSteps: ["completed"].map(dLT),
        activeSteps: ["testing"].map(dLT),
    }),
    completed: ensureArrays({
        completeSteps: ["uploaded", "completed", "testing"].map(dLT),
        incompleteSteps: [],
        activeSteps: [],
    }),
    updating: ensureArrays({
        completeSteps: ["uploaded"].map(dLT),
        incompleteSteps: ["completed"].map(dLT),
        activeSteps: ["updating"].map(dLT),
    }),
    failed: ensureArrays({
        completeSteps: ["uploaded"].map(dLT),
        incompleteSteps: [],
        activeSteps: [],
        failedSteps: ["testing"].map(dLT),
    }),
    error: ensureArrays({
        completeSteps: ["uploaded"].map(dLT),
        incompleteSteps: [],
        activeSteps: [],
        failedSteps: ["testing"].map(dLT),
    }),
    noData: ensureArrays({
        completeSteps: ["uploaded"].map(dLT),
        incompleteSteps: [],
        activeSteps: [],
        failedSteps: ["testing"].map(dLT),
    }),
};

const testLD = {
    other: {
        yNotAvailable: ensureArrays({
            completeSteps: ["shipped", "returned", "testing", "completed"].map(d),
            activeSteps: [],
            incompleteSteps: ["yNotAvailable"].map(d),
            useIncomplete: true,
        }),
        familyMatching: {
            notOptedIn: ensureArrays({
                incompleteSteps: ["notOptedIn", "pending", "findingMatches", "completed"].map(dFN),
                completeSteps: [],
                activeSteps: [],
            }),
            pending: ensureArrays({
                completeSteps: ["optedIn"].map(dFN),
                activeSteps: ["pending"].map(dFN),
                incompleteSteps: ["findingMatches", "completed"].map(dFN),
            }),
            processing: ensureArrays({
                completeSteps: ["optedIn"].map(dFN),
                activeSteps: ["findingMatches"].map(dFN),
                incompleteSteps: ["completed"].map(dFN),
            }),
            completed: ensureArrays({
                completeSteps: ["optedIn", "pending", "findingMatches", "completed"].map(dFN),
                activeSteps: [],
                incompleteSteps: [],
            }),
        },
    },
    testing: ensureArrays({
        completeSteps: ["shipped", "enRoute", "returned"].map(d),
        activeSteps: ["testing"].map(d),
        incompleteSteps: ["completed"].map(d),
    }),
    updating: ensureArrays({
        completeSteps: ["requestedUpdate"].map(d),
        activeSteps: ["updating"].map(d),
        incompleteSteps: ["updateComplete"].map(d),
    }),
    processing: ensureArrays({
        completeSteps: ["shipped", "enRoute", "returned"].map(d),
        activeSteps: ["testing"].map(d),
        incompleteSteps: ["completed"].map(d),
    }),
    pending: ensureArrays({
        completeSteps: ["shipped", "returned"].map(d),
        activeSteps: [],
        incompleteSteps: ["testing", "completed"].map(d),
    }),
    completed: ensureArrays({
        completeSteps: ["shipped", "enRoute", "returned", "testing", "completed"].map(d),
        activeSteps: [],
        incompleteSteps: [],
    }),
    error: ensureArrays({
        completeSteps: ["shipped", "enRoute", "returned"].map(d),
        activeSteps: [],
        incompleteSteps: [],
        failedSteps: ["testing"].map(d),
    }),
    failed: ensureArrays({
        completeSteps: ["shipped", "enRoute", "returned"].map(d),
        activeSteps: [],
        incompleteSteps: [],
        failedSteps: ["testing"].map(d),
    }),
    noData: ensureArrays({
        completeSteps: ["shipped", "enRoute", "returned"].map(d),
        activeSteps: [],
        incompleteSteps: [],
        failedSteps: ["testing"].map(d),
    }),
};

export const upgradeSteps = {
    notAdded: ensureArrays({
        incompleteSteps: ["notAdded", "processing", "completed"].map(du),
    }),
    pending: ensureArrays({
        completeSteps: ["pending"].map(du),
        activeSteps: [],
        incompleteSteps: ["processing", "completed"].map(du),
    }),
    processing: ensureArrays({
        completeSteps: ["pending"].map(du),
        activeSteps: ["processing"].map(du),
        incompleteSteps: ["completed"].map(du),
    }),
    updating: ensureArrays({
        completeSteps: ["pending"].map(du),
        activeSteps: ["updating"].map(du),
        incompleteSteps: ["completed"].map(du),
    }),
    completed: ensureArrays({
        completeSteps: ["pending", "processing", "completed"].map(du),
        activeSteps: [],
        incompleteSteps: [],
    }),
    failed: ensureArrays({
        completeSteps: ["pending"].map(du),
        failedSteps: ["processing"].map(du),
    }),
    error: ensureArrays({
        completeSteps: ["pending"].map(du),
        failedSteps: ["processing"].map(du),
    }),
    noData: ensureArrays({
        completeSteps: ["pending"].map(du),
        failedSteps: ["processing"].map(du),
    }),
};

export const kitSteps = {
    lt: kitLT,
    ld: kitLD,
};

// Failed steps are normally labelled "<step> failed", which only reads correctly for a step that
// names a stage of the process. These already describe an outcome, so they are shown as they are
// rather than becoming "Cancelled failed" / "Lost in the post failed".
export const SELF_DESCRIBING_FAILURES = ["Cancelled", "Lost in the post"];

export const failedStepName = (step) =>
    SELF_DESCRIBING_FAILURES.includes(step?.name) ? step.name : `${step?.name || "Step"} failed`;

// The timeline for a kit at the given status: an upload's (LT) or a physical kit's. A status the
// timelines don't cover reads as just activated (or, for an upload, being tested), as the
// profile pill does.
export const kitTimeline = (barcode, rawStatus) => {
    const kind = barcode?.startsWith("LT") ? "lt" : "ld";
    return kitSteps[kind][rawStatus] ?? kitSteps[kind][kind === "lt" ? "testing" : "shipped"];
};

// Whether the kit has failed, been cancelled or been lost: it will never produce results.
export const isFailedKitStatus = (barcode, rawStatus) =>
    kitTimeline(barcode, rawStatus).failedSteps.length > 0;

// What happened to a kit that will never produce results, as the pages tell the customer: the lead
// sits above the kit's progress, the summary where the progress isn't shown (the dashboard).
export const KIT_FAILURES = {
    testing_failed: {
        title: "We couldn't get a result from your sample",
        lead: "This can happen with a sample. See your kit's progress below for what happens next.",
        summary: "This can happen with a sample, and we may be able to send you a new sample kit.",
    },
    cancelled: {
        title: "Your kit has been cancelled",
        lead: "If you weren't expecting this, contact help@livingdna.com.",
    },
    lost_in_post: {
        title: "Your kit didn't reach you",
        lead: "Contact help@livingdna.com and we'll sort out a replacement.",
    },
};

// A posted kit's statuses before it has results: on its way through the lab, or stopped on the
// way. Listed rather than "not completed", as a status the timelines don't know would otherwise
// read as just activated.
const KIT_PENDING_STATUSES = [
    "shipped", "returned", "genotyping", "testing", "testing_failed", "cancelled", "lost_in_post",
];

// Whether `barcode` is a posted ancestry kit with no results yet. Uploads (LT) and epigenetics
// kits (E) have pages of their own, and a missing status (tests not loaded) counts as no, so
// pages fall back to what they showed before.
export const isAncestryKitPending = (barcode, rawStatus) =>
    !!barcode && !barcode.startsWith("LT") && !barcode.endsWith("E") &&
    KIT_PENDING_STATUSES.includes(rawStatus);

// Whether `barcode` is an upload (LT) without results: still being tested, or failed. Nothing
// that builds on its DNA can be offered yet. A missing status (tests not loaded) counts as no.
export const isUploadWithoutResults = (barcode, rawStatus) =>
    !!barcode?.startsWith("LT") && !!rawStatus && rawStatus !== "completed";

// The step a kit is at: the one under way, or the one it failed at. Null for a finished kit.
export const currentKitStep = (barcode, rawStatus) => {
    const { activeSteps, failedSteps } = kitTimeline(barcode, rawStatus);
    if (failedSteps.length) return { name: failedStepName(failedSteps[0]), duration: null };
    if (!activeSteps.length) return null;
    const { name, duration } = activeSteps[0];
    return { name, duration: duration && duration !== "-" ? duration : null };
};

export const kitTestSteps = {
    lt: testLT,
    ld: testLD,
};

export const vitaminSubscription = {
    notAdded: ensureArrays({
        completeSteps: [],
        activeSteps: [],
        incompleteSteps: ["added"].map(dVit),
    }),
    active: ensureArrays({
        completeSteps: ["added"].map(dVit),
        activeSteps: [],
        incompleteSteps: ["expiringSoon", "expired"].map(dVit),
    }),
    expiringSoon: ensureArrays({
        completeSteps: ["added"].map(dVit),
        activeSteps: ["expiringSoon"].map(dVit),
        incompleteSteps: ["expired"].map(dVit),
    }),
    expired: ensureArrays({
        completeSteps: ["added", "expiringSoon"].map(dVit),
        failedSteps: ["expired"].map(dVit),
        activeSteps: [],
        incompleteSteps: [],
    }),
};

export const healthProfile = {
    notCreated: ensureArrays({
        completeSteps: [],
        incompleteSteps: ["create"].map(dHealth),
    }),
    created: ensureArrays({
        completeSteps: ["create"].map(dHealth),
        incompleteSteps: [],
    }),
};
